import { useState } from 'react';

export function useTableSearch<T>() {
  const [searchQuery, setSearchQuery] = useState('');

  const getFilteredData = (data: T[], searchFields: (item: T) => string[]) => {
    if (!searchQuery.trim()) return data;

    const query = searchQuery.toLowerCase().trim();
    return data.filter(item => 
      searchFields(item).some(field => 
        field.toLowerCase().includes(query)
      )
    );
  };

  return {
    searchQuery,
    setSearchQuery,
    getFilteredData
  };
} 